import * as React from 'react';

import { ComplainModalContext } from './context';

export const useComplainModalContext = () => React.useContext(ComplainModalContext);
